export const PRONOUN_OPTIONS = [
  { value: "he/him", label: "He/Him" },
  { value: "she/her", label: "She/Her" },
  { value: "they/them", label: "They/Them" },
  { value: "he/they", label: "He/They" },
  { value: "she/they", label: "She/They" },
] as const;
